/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PressKitTag
 */
export interface PressKitTag {
    /**
     * 各タグに設定されるUUID。クエリパラメータとしてURLでも利用される。
     * @type {string}
     * @memberof PressKitTag
     */
    readonly id: string;
    /**
     * UI上で表示されるタグの名前。
     * @type {string}
     * @memberof PressKitTag
     */
    readonly name: string;
}

export function PressKitTagFromJSON(json: any): PressKitTag {
    return PressKitTagFromJSONTyped(json, false);
}

export function PressKitTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitTag {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function PressKitTagToJSON(value?: PressKitTag | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

